export const duzenlemeKuruluData = [
  {
    teamName: "duzenlemeKurulu",
    members: [
      {
        firstName: "Selahattin",
        lastName: "KAYNAK",
        academicTitle: "Prof. Dr."

      },
      {
        firstName: "Salih",
        lastName: "KESGİN",
        academicTitle: "Prof. Dr."

      },
      {
        firstName: "Ali",
        lastName: "BİLGİN",
        academicTitle: "Prof. Dr."

      },
      {
        firstName: "Adem",
        lastName: "SORUÇ",
        academicTitle: "Doç. Dr."

      },
      {
        firstName: "Mustafa Kemal",
        lastName: "YILMAZ",
        academicTitle: "Prof. Dr."
      },
      {
        firstName: "Zafer",
        lastName: "CÖMERT",
        academicTitle: "Doç. Dr."
      },
      {
        firstName: "Cumhur",
        lastName: "TÜRK",
        academicTitle: "Doç. Dr."
      },
      {
        firstName: "Mustafa Uğur",
        lastName: "KARADENİZ",
        academicTitle: "Doç. Dr."
      },
      {
        firstName: "Mücahit",
        lastName: "YILDIRIM",
        academicTitle: "Doç. Dr."
      },
      {
        firstName: "Engin",
        lastName: "BAYTÜRK",
        academicTitle: "Dr. Öğr. Üyesi"
      },
      {
        firstName: "Ahmet Emin",
        lastName: "ŞEN",
        academicTitle: ""

      },
      {
        firstName: "Tayfun",
        lastName: "ŞENER",
        academicTitle: ""
      }
    ]
  }
];

export default duzenlemeKuruluData;
